import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../provider/authProvider";

// Guard untuk halaman publik (login/register/reset).
// Jika user SUDAH login, redirect ke halaman utama agar tidak balik ke login.
export const PublicRoute = () => {
  const { token } = useAuth();

  if (token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
